import { Map } from 'immutable';

export default Map({
  unstyled: {
    element: 'div',
    // will be used in convertFromHTMLtoContentBlocks
    aliasedElements: [
      'address',
      'article',
      'h1',
      'header',
      'blockquote',
      'p',
      'pre',
      'section',
      'summary',
      'time',
    ],
  },
  'header-one': {
    element: '',
  },
  'header-two': {
    element: 'h2',
  },
  'header-three': {
    element: 'h3',
  },
  'header-four': {
    element: 'h4',
  },
  'header-five': {
    element: 'h5',
  },
  'header-six': {
    element: 'h6',
  },
  blockquote: {
    element: '',
  },
  atomic: {
    element: '',
  },
  'code-block': {
    element: '',
  },
});
